import React, {Component} from "react"
import {connect} from "react-redux";
import withStyles from "@mui/styles/withStyles";
import CardContent from "@mui/material/CardContent";
import TextField from "@mui/material/TextField";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import {clear_auth_messages, clear_password_change_status, reset_password} from "../../actions/auth";
import SnackbarMessage from "../Custom/SnackbarMessage";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ReCAPTCHA from "react-google-recaptcha";
import CircularProgress from "@mui/material/CircularProgress";
import Validator from "../../utilities/validator";
import {switchMode} from "../../actions/theming";

const styles = {
    loginPage: {
        height: "85vh",
        paddingTop: "15vh",
        //background: "linear-gradient(45deg, rgb(0, 126, 255) 0%, rgb(100, 234, 255) 100%);"
        //background: "url(" + bg + ")",
        // https://www.google.com/search?q=database%20wallpaper&tbm=isch&tbs=isz%3Al&hl=sk&ved=0CAEQpwVqFwoTCIi9gIum7-cCFQAAAAAdAAAAABAl&biw=1905&bih=981#imgrc=IW2Na3t1rh94bM
        // bg source http://eskipaper.com/free-background-wallpaper-9.html
        /*backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover"*/
    },
    password: {
        "margin-top": 10
    },
    centered: {
        "text-align": "center",
        "paddingTop": 24,
        "paddingBottom": 24
    },
    loginWrapper: {
        textAlign: "center",
        paddingTop: "40px",
        minHeight: "calc(100vh - 83px)",
        marginBottom: "60px"
    },
    logo: {
        paddingTop: 15,
        paddingBottom: 15,
        fontWeight: "bold",
        color: "white"
    },
    loginButtons: {
        flexDirection: "row-reverse"
    },
    loginHint: {
        flex: "auto"
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -10,
        marginLeft: -10,
    },
    buttonProgressContainer: {
        position: 'relative'
    },
    backToLogin: {
        marginBottom: 10
    },
    darkModeSwitch: {
        position: "fixed",
        top: "10px",
        right: "10px"
    }
};


class ResetPassword extends Component {

    constructor(props) {
        super(props);
        this.recaptchaRef = React.createRef();
        this.state = {
            password: "",
            password_repeat: "",
            passwordTouched: false,
            password_repeatTouched: false
        };
    }

    componentDidMount() {
        this.props.clear_auth_messages();
        if (!window.PASSWORD_RESET) {
            this.props.history.push("/");
        }
    }

    onSubmit = e => {
        e.preventDefault();
        this.recaptchaRef.current.execute().then(res => {
            const recaptchaToken = res;
            const {password, password_repeat} = this.state;
            if (!(password.length === 0 || password_repeat.length === 0 || password !== password_repeat) && Validator.isPasswordValid(password)) {
                this.props.reset_password(window.PASSWORD_RESET["email"], window.PASSWORD_RESET["token"], password, password_repeat, recaptchaToken);
            } else {
                this.setState({
                    ...this.state,
                    passwordTouched: true,
                    password_repeatTouched: true
                });
            }
        });


    };

    onChange = e => this.setState({
        ...this.state,
        [e.target.name]: e.target.value,
        [e.target.name + 'Touched']: true
    });

    render() {
        const {classes} = this.props;
        const {password, password_repeat, passwordTouched, password_repeatTouched} = this.state;

        let errors = false;
        if (this.props.auth.password_changed !== null) {
            if (this.props.auth.password_changed.status === "success") {
                window.PASSWORD_RESET = false;
                this.props.history.push("/");
            } else if (this.props.auth.password_changed.status === "error") {
                if (this.props.auth.password_changed.errors) {
                    let errors_array = [];
                    Object.keys(this.props.auth.password_changed.errors).map((field) => {
                        errors_array = [...errors_array, ...this.props.auth.password_changed.errors[field]];
                    });
                    errors = (
                        <>
                            <SnackbarMessage onClose={this.props.clear_password_change_status} type="error"
                                             message={errors_array.join(", ")} autoHideDuration={null}
                                             anchorOrigin={false}
                                             style={{marginBottom: 15}}/>
                        </>
                    )
                } else {
                    errors = (
                        <>
                            <SnackbarMessage onClose={this.props.clear_password_change_status} type="error"
                                             message={this.props.auth.password_changed.message} autoHideDuration={null}
                                             anchorOrigin={false}
                                             style={{marginBottom: 15}}/>
                        </>
                    )
                }
            }
        }
        return (
            <form onSubmit={this.onSubmit} id="reset-password">
                <CardContent>
                    <Button color="inherit" disabled={this.props.auth.is_waiting}
                            className={classes.backToLogin}
                            onClick={(e) => {
                                e.preventDefault();
                                this.props.history.push("/auth/login")
                            }}
                            size="small"
                            startIcon={<ChevronLeftIcon/>}
                    >Back to login</Button>
                    {errors}
                    <TextField fullWidth label="E-mail" type="email"
                               defaultValue={window.PASSWORD_RESET["email"]} disabled={true}/>
                    <TextField fullWidth className={classes.password} label="New password"
                               type="password"
                               name="password" onChange={this.onChange} value={password}
                               error={passwordTouched && !Validator.isPasswordValid(password)}
                               helperText={passwordTouched && !Validator.isPasswordValid(password) ? "Minimum 8 characters, at least one uppercase letter, one lowercase letter and one number" : ""}
                    />

                    <TextField fullWidth className={classes.password} label="New password repeat"
                               type="password"
                               name="password_repeat" onChange={this.onChange} value={password_repeat}
                               error={password_repeatTouched && password_repeat !== password}
                               helperText={password_repeatTouched && password_repeat !== password ? "Please confirm your password" : ""}
                    />

                    <ReCAPTCHA
                        ref={this.recaptchaRef}
                        size="invisible"
                        sitekey="6LcpS7kaAAAAACvn4UE6Mui2XRYfVyOSZROzvF9I"
                        // onChange={onChange}
                    />
                </CardContent>
                <CardActions className={classes.loginButtons}>
                    <div className={classes.buttonProgressContainer}>
                        <Button type="submit"
                                variant="contained"
                                color="primary"
                                disabled={this.props.auth.is_waiting || password.length === 0 || password_repeat.length === 0 || password !== password_repeat || !Validator.isPasswordValid(password)}
                        >
                            Change
                        </Button>
                        {this.props.auth.is_waiting &&
                        <CircularProgress size={20} className={classes.buttonProgress}/>}
                    </div>
                </CardActions>
            </form>
        )
    }
}

const mapStateToProps = state => ({
    auth: state.auth,
    theming: state.theming
});

export default withStyles(styles)(connect(
    mapStateToProps,
    {reset_password, clear_password_change_status, switchMode, clear_auth_messages}
)(ResetPassword));
